import styled, { css } from "styled-components"

import { Color, IsMobile, LineHeight, RadiusSize, SpacingSize, TextSize } from "~/consts/style-mixins"

export const CareerPathCardStack = styled.div`
  margin-top: ${SpacingSize.M}px;
  display: grid;
  grid-gap: ${SpacingSize.XL}px;
  grid-template-columns: 1fr 1fr;
  ${IsMobile(css`
    grid-template-columns: 1fr;
  `)}
`

export const Card = styled.div`
  padding: 24px;
  border: 1px solid ${Color.BorderGray};
  background-color: ${Color.White};
  border-radius: ${RadiusSize.Medium}px;
  line-height: ${LineHeight.S}%;
`

export const CardTop = styled.div``

export const CardTopDescription = styled.div`
  margin-top: ${SpacingSize.XS}px;
  font-size: ${TextSize.S}px;
`

export const CardBottom = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${SpacingSize.M}px;
`

export const CardItem = styled.div`
  display: flex;
  & + & {
    margin-top: ${SpacingSize.XS}px;
  }
`

export const CardItemIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  border-radius: 100%;
  background-color: ${Color.BackgroundGray};
`

export const CardItemRight = styled.div`
  margin-left: ${SpacingSize.XS}px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const CardItemRightTitle = styled.div`
  font-size: ${TextSize.S}px;
`

export const CardItemRightSchedule = styled.div`
  font-size: ${TextSize.XS}px;
  color: ${Color.Gray};
`
